import * as types from '../actions/Security/types';

export const initialState = {
	isPasswordCorrect: false,
};

const securityReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.PASSWORD_ENTERED:
			console.log('here');
			const { isPasswordCorrect } = action;
			return {
				...state,
				isPasswordCorrect,
			};

		default:
			return state;
	}
};

export default securityReducer;



// WEBPACK FOOTER //
// ./src/reducers/security.js